import { useId } from 'react';
import { cn } from '@/utils';
import { Controller, useFormContext } from 'react-hook-form';

import { Checkbox } from '@/components/ui/Checkbox';

type Props = {
  label: string | React.ReactNode;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  labelProps?: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >;
  /** Explicit id for the checkbox. Auto-generated if omitted. */
  id?: string;
};

const InputCheck = ({ label, inputProps, labelProps, id: externalId }: Props) => {
  const generatedId = useId();
  const id = externalId ?? generatedId;

  // Adaptador para convertir entre los tipos de eventos
  const handleCheckedChange = (checked: boolean) => {
    if (inputProps?.onChange) {
      const syntheticEvent = {
        target: { checked },
        currentTarget: { checked },
      } as React.ChangeEvent<HTMLInputElement>;
      inputProps.onChange(syntheticEvent);
    }
  };

  return (
    <div className="input-check flex items-center space-x-3">
      <Checkbox
        id={id}
        className={cn(
          'h-5 w-5 border-4 border-primary data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-white [&_svg]:-translate-y-[2px]',
          inputProps?.className
        )}
        checked={inputProps?.checked}
        onCheckedChange={handleCheckedChange}
        aria-required={inputProps?.required}
      />
      <label
        htmlFor={id}
        className={cn(
          'cursor-pointer select-none font-workSans font-normal leading-4 text-tundora',
          labelProps?.className
        )}
        {...labelProps}
      >
        {label}
      </label>
    </div>
  );
};

export const InputCheckForm = ({ currentId, label }: { currentId: string; label: string }) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={currentId}
      control={control}
      render={({ field: { onChange, value, ...field } }) => (
        <div className="input-check flex items-center space-x-3">
          <Checkbox
            id={currentId}
            className="h-5 w-5 border-[3px] border-primary data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-white [&_svg]:-translate-y-[2px]"
            checked={value}
            onCheckedChange={onChange}
            {...field}
          />
          <label
            htmlFor={currentId}
            className="cursor-pointer select-none font-workSans font-normal leading-4 text-tundora"
          >
            {label}
          </label>
        </div>
      )}
    />
  );
};

export default InputCheck;
